<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage">
    <div class="project-folders-header">
        <div requiredAsterisk>{{projectNameLabel}} Folders </div>
        <button [disabled]="!isNewFolderButtonEnabled()" class="new-folder-button-section" [attr.data-automation-id]="modalAutomationId + '-new-folder-button'"
             [ngClass]="[isNewFolderButtonEnabled() ? 'btn-enabled' : 'btn-disabled']"
             (click)="createEditNewFolder(tree.selectedNode)"><i
                class="fa fa-plus"></i><span>New Folder ...</span></button>
    </div>
    <div class="tree-container">
        <res-generic-tree automationId="target-picker-tree" [loadNodeDataCallback]="loadNodeDataCallback">
        </res-generic-tree>
    </div>
</res-base-modal>
